module.exports = __webpack_public_path__ + "static/media/step_009.e3bd8c7e.png";